export default __webpack_public_path__ + "static/media/exam-list-header-bg.b1491a76.png";